"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconDashboard = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var IconDashboard = function IconDashboard(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M1.313 13.5h8.25a1.336 1.336 0 001.312-1.352V1.352C10.875.605 10.285 0 9.562 0h-8.25A1.331 1.331 0 000 1.352v10.796c0 .747.59 1.352 1.313 1.352zM0 22.75C0 23.441.59 24 1.313 24h8.25c.722 0 1.312-.559 1.312-1.25v-5.793c0-.691-.59-1.25-1.313-1.25h-8.25c-.722 0-1.312.559-1.312 1.25zm13.176-.082c0 .734.59 1.332 1.312 1.332h8.2A1.322 1.322 0 0024 22.668v-9.332A1.323 1.323 0 0022.687 12h-8.199a1.322 1.322 0 00-1.312 1.332zm1.312-12.844h8.2c.343.004.675-.129.921-.37.246-.243.387-.571.391-.915V1.285A1.297 1.297 0 0022.687 0h-8.199a1.3 1.3 0 00-1.312 1.285V8.54c0 .707.59 1.285 1.312 1.285zm0 0"
  }));
};
exports.IconDashboard = IconDashboard;